import {CIPHER_DAILY_REVERT_TO_IDLE_TIME, DAILY_GAME_STORE_INITIAL_STATE} from './DailyGameStore.constants';
import {DailyGameConfig, DailyGameInputItem, DailyGameInputLetterStatus, DailyGameState} from './DailyGameStore.types';
import {DI_TOKENS} from '@/di/di.tokens';

import {injected} from 'brandi';

import {Store} from '@/stores/Store';
import {GlobalWindow} from '@/types';

export class DailyGameStore extends Store<DailyGameState> {
  constructor(private readonly globalWindow: GlobalWindow) {
    super(DAILY_GAME_STORE_INITIAL_STATE);
  }

  public setConfig(config: DailyGameConfig): void {
    this.setValue('config', config);
    this.setInitialCipher(config.keyboardSymbols.join(''));
    this.setValue('cipher', '');
  }

  public setInputItemStatus(key: number, status: DailyGameInputLetterStatus): void {
    const newInputCipher = this.state.inputCipher.reduce<DailyGameInputItem[]>((cipher, item) => {
      if (key === item.key) {
        item.status = status;

        if (status === DailyGameInputLetterStatus.Valid) {
          this.setValue('cipher', this.state.cipher + item.letter);
        }

        if (status === DailyGameInputLetterStatus.Invalid) {
          this.globalWindow.setTimeout(
            () => this.setInputItemStatus(key, DailyGameInputLetterStatus.Idle),
            CIPHER_DAILY_REVERT_TO_IDLE_TIME,
          );
        }
      }

      cipher.push(item);

      return cipher;
    }, []);

    this.setValue('inputCipher', newInputCipher);
  }

  public setWasFail(): void {
    this.setValue('isWasFails', true);
  }

  public isDailyGameCompleted(): boolean {
    if (this.state.config.cipherLength === 0) return false;

    return (
      this.state.inputCipher.filter((item) => this.isInputItemValidStatus(item)).length ===
      this.state.config.cipherLength
    );
  }

  public getReward(): number {
    return this.state.config.reward;
  }

  public showResultModal(): void {
    this.setValue('showResultModal', true);
  }

  public hideResultModal(): void {
    this.setValue('showResultModal', false);
  }

  public isShowResultModal(): boolean {
    return this.state.showResultModal;
  }

  public getCipherString(): string {
    return this.state.cipher;
  }

  public getInputItems(): DailyGameInputItem[] {
    return this.state.inputCipher;
  }

  public getCipherLength(): number {
    return this.state.config.cipherLength;
  }

  public isInputItemIdleStatus(inputItem: DailyGameInputItem): boolean {
    return inputItem.status === DailyGameInputLetterStatus.Idle;
  }

  public isInputItemValidStatus(inputItem: DailyGameInputItem): boolean {
    return inputItem.status === DailyGameInputLetterStatus.Valid;
  }

  public isInputItemInvalidStatus(inputItem: DailyGameInputItem): boolean {
    return inputItem.status === DailyGameInputLetterStatus.Invalid;
  }

  public isInputItemFetchingStatus(inputItem: DailyGameInputItem): boolean {
    return inputItem.status === DailyGameInputLetterStatus.Fetching;
  }

  public isWasFails(): boolean {
    return this.getState().isWasFails;
  }

  private setInitialCipher(cipher: string): void {
    this.setValue(
      'inputCipher',
      [...cipher].map((letter, key) => ({
        letter,
        key,
        status: DailyGameInputLetterStatus.Idle,
      })),
    );
  }
}

injected(DailyGameStore, DI_TOKENS.globalWindow);
